import React, { useState } from 'react';
import { Link } from "react-router-dom";
import Hero from './components/Hero';
import Header from './components/Header';
import FAQ from "./components/FAQ";
import DigitalIdentity from './components/DigitalIdentity';
import Testimonial from './components/Testimonial';
import Pricing from './components/Pricing';
import Footer from './components/Footer';



export default function Home() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="font-sans">
        <Header/>
        <Hero/>
        <DigitalIdentity/>
        <Testimonial/>
        <FAQ/>
        <Footer/>
    </div>
  );
}
